import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';
import { AuthService } from '../../Services/auth.service';
import { BaseApiService } from '../../Services/base-api.service';
import { NotificationMessages } from '../../Models/Notifications/NotifiyMessages';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { BaseComponent } from '../../Base/base/base.component';
import { takeUntil, finalize } from 'rxjs';



@Component({
  selector: 'app-user-interest-news',
  templateUrl: './user-interest-news.component.html',
  styleUrls: ['./user-interest-news.component.css'],standalone:false
})
export class UserInterestNewsComponent extends BaseComponent  {
//declarations
  loading:boolean=false;
  notifications:NotificationMessages[]=[]
  SingleNotification!:NotificationMessages
  ShowDialog(notification:NotificationMessages){
    this.SingleNotification=notification;
    this.visible=true;
  }
  userRole:string=''
  userId:string=''
  //Initilization
  user1:string=''
  interests: string[] = [];
  visible: boolean = false;
  pageNumber: number = 1;
  canGoNext = false;
  canGoPrev = false;
  constructor
  (
       private api:BaseApiService,
       private messageService:MessageService,
       private auth :AuthService,
       private sanitizer: DomSanitizer,
  )
  {
       super();
       this.userRole =this.auth.getRoles().toString();
       this.userId   =this.auth.getUID();
  }



  //Getting news
  GetNotifications(userId:string){
    this.loading=true;
    this.api.read(`Profile_Service/NotificationsPages?userid=${userId}&type=AIFilteredNewsAlerts&pageNumber=${this.pageNumber}`)
     .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
     )
    .subscribe
    (
       {
        next:(response)=>{
          this.notifications   = response;
          this.loading         = false;
          // Optional: Disable "Next" if returned items < 7
          this.canGoNext = response.length === 7;
          this.canGoPrev = this.pageNumber > 1;

        },
        error:(
          error
        )=>{
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
       }
    )
  }


  goToNext(userId: string) {
    if (this.canGoNext) {
      this.pageNumber++;
      this.GetNotifications(userId);
    }
  }
  
  goToPrev(userId: string) {
    if (this.pageNumber > 1) {
      this.pageNumber--;
      this.GetNotifications(userId);
    }
  }

  GetAll(uid:any){
    this.loading=true;
    this.api.read(`Auth/GetUserInterest?username=${uid}`)
    .pipe(
      takeUntil(this.destroy$),
      finalize(() => {
        this.loading = false;
      })
    )
    .subscribe
    (
      {
        next:(response)=>{
          this.user1     = response;
          this.interests = this.user1.split(',').map((interest) => interest.trim());
  
          this.loading=false;
        }
        ,
        error:(
          error
        )=>{
  
          this.loading=false;
          this.messageService.add({ severity: 'error', summary: 'Error', detail: error });
        }
      }
    )
   }

  //Calling
  ngOnInit(): void
  {
    this.GetAll(this.userId);
    this.GetNotifications(this.userId);
  }


   sanitizeHtml(htmlContent: string): SafeHtml {
     return this.sanitizer.bypassSecurityTrustHtml(htmlContent);
   }
  
   sanitizeHtmlWithImageFix(html: string) {
    const tempDiv = document.createElement('div');
    tempDiv.innerHTML = html;
  
    const images = tempDiv.querySelectorAll('img');
    let imageSrc = '';
  
    images.forEach((img: HTMLImageElement, index: number) => {
      img.style.maxWidth = '100%';
      img.style.height = 'auto';
      img.style.objectFit = 'cover';
      img.classList.add('img-fluid', 'rounded-2', 'shadow', 'my-2');
  
      if (index === 0) {
        imageSrc = img.src;
        img.remove(); 
      }
    });
  
    return {
      sanitizedHtml: this.sanitizer.bypassSecurityTrustHtml(tempDiv.innerHTML),
      imageSrc: imageSrc
    };
  }

}
